module.exports = __webpack_public_path__ + "img/bg-redeem-gold.9b645ea6.png";